/**
 * Expose isArray
 */

module.exports = isArray['default'] = isArray

/**
 * isArray
 */

function isArray (val) {
  return Array.isArray(val)
}



//////////////////
// WEBPACK FOOTER
// ../~/@f/is-array/lib/index.js
// module id = 388
// module chunks = 0